import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import React from 'react';

import CustomTooltip from '../../CustomTooltip';
import SortingArrows from '../../images/sorting-arrows';
import TableCell from '../TableCell';
import TableHeaderCellLabel from '../TableHeaderCellLabel';

interface Cell {
  id: string;
  numeric: boolean;
  label: string;
  tooltipTitle: string;
  sortable: boolean;
}

export interface SortableTableHeaderProps {
  cells: Cell[];
  sortDirection?: 'asc' | 'desc';
  sortColumn?: string;
  onRequestSort?: (event: React.MouseEvent<HTMLSpanElement>, property: string) => void;
}

export const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  cells,
  sortDirection,
  sortColumn,
  onRequestSort = () => null,
}) => {
  const createSortHandler = (property: string) => (event: React.MouseEvent<HTMLSpanElement>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {cells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            sortDirection={sortColumn === headCell.id ? sortDirection : false}
          >
            <CustomTooltip dense title={headCell.tooltipTitle}>
              {headCell.sortable ? (
                <TableSortLabel
                  active={sortColumn === headCell.id}
                  direction={sortColumn === headCell.id ? sortDirection : 'asc'}
                  IconComponent={() => (
                    <SortingArrows sortDirection={(sortColumn === headCell.id && sortDirection) || undefined} />
                  )}
                  onClick={createSortHandler(headCell.id)}
                >
                  <TableHeaderCellLabel label={headCell.label} />
                </TableSortLabel>
              ) : (
                <TableHeaderCellLabel label={headCell.label} />
              )}
            </CustomTooltip>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default SortableTableHeader;
